import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDateTime } from "@/lib/api";
import { ClipboardList, ChevronDown } from "lucide-react";

export function ChecklistPendingCard() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/checklist-pending").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list.length) { return null; }
  return (
    <section data-testid="checklist-pending-card" className="rounded-2xl lg:rounded-xl border border-violet-700/60 bg-violet-950/25 p-4 lg:p-3">
      <button type="button" data-testid="checklist-pending-toggle" onClick={() => setOpen((o) => !o)} aria-expanded={open}
        className="w-full flex items-center gap-3 text-left">
        <span className="h-10 w-10 lg:h-8 lg:w-8 rounded-xl lg:rounded-lg bg-violet-500/20 text-violet-200 inline-flex items-center justify-center shrink-0"><ClipboardList className="h-5 w-5 lg:h-4 lg:w-4" /></span>
        <span className="flex-1 min-w-0">
          <span className="block text-[11px] font-mono-caps text-violet-300/80">Checklist pendente</span>
          <span data-testid="checklist-pending-count" className="font-display text-xl lg:text-base font-black text-violet-100">{list.length} OS <span className="text-xs font-sans text-violet-300/70 font-normal">aguardando preenchimento</span></span>
        </span>
        <ChevronDown className={`h-4 w-4 text-violet-300 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="mt-3 space-y-1.5 border-t border-violet-900/70 pt-3">
          {list.map((o) => (
            <li key={o.id}>
              <Link to={`/owner/ordens/${o.id}`} data-testid={`checklist-pending-item-${o.id}`}
                className="flex items-center gap-3 rounded-lg px-2 py-2 text-sm hover:bg-violet-900/30">
                <span className="font-mono tabular-nums text-violet-200 shrink-0">#{o.order_number}</span>
                <span className="font-mono text-xs tracking-widest uppercase text-zinc-300 shrink-0">{o.plate || "—"}</span>
                <span className="flex-1 min-w-0 truncate text-zinc-100">{o.customer_name || "Cliente —"}</span>
                <span className="text-[11px] text-zinc-500 shrink-0">{fmtDateTime(o.created_at)}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
